<template>
  <div class="filter-item flex text-xs font-semibold text-abbey">
    <BaseCheckbox
      :checked="checked"
      :id="id"
      @toggle="onChange"
      v-if="multiselect"
    >
      <span>{{ name }}</span>
      <span class="text-dusty-gray font-normal pl-1" v-if="count != null">
        ({{ count }})
      </span>
    </BaseCheckbox>
    <BaseRadioButton :checked="checked" :id="id" @check="onChange" v-else>
      <span>{{ name }}</span>
      <span class="text-dusty-gray font-normal pl-1" v-if="count != null">
        ({{ count }})
      </span>
    </BaseRadioButton>
  </div>
</template>

<script>
export default {
  name: 'FilterItem',
  props: {
    checked: {
      type: Boolean,
      required: true
    },
    id: {
      required: true,
      validator: function(value) {
        return ['number', 'string'].includes(typeof value)
      }
    },
    name: {
      type: String
    },
    multiselect: {
      type: Boolean,
      default: false
    },
    count: {
      type: Number
    }
  },
  methods: {
    onChange(value) {
      this.$emit('change', { id: value, name: this.name })
    }
  }
}
</script>
